export default __webpack_public_path__ + "static/media/community-home-cropped.03991f6f.jpg";